module.exports = __webpack_public_path__ + "img/banner-no-poverty.1a78df5c.png";